/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import I18n from 'i18n-js';
import { SolicitudPendiente } from 'types/models/SolicitudesPendientesNuevoOnboarding';
import { SectionTitle } from 'components';
import { InscritosModel } from 'types/models/inscritos';
import { CommunitiesService } from 'services/remote/communities-service';
import { CommunityModel } from 'types/models/community';

import { FormGroup, FormGroupProps } from 'core';
import { FORMGROUP_TYPES } from 'core/form/FormGroup/FormGroup';
import styles from '../../comunities-solicitudes-pendiente-list-page-new-onboarding-detalle.module.scss'; // ajusta si lo mueves

interface DatosPersonalesProps {
  vieneDeInscritos: boolean;
  inscrito: InscritosModel | undefined;
  solicitudesPendientes: SolicitudPendiente | undefined;
  handleChange: (path: string, value: any) => void;
}

const DatosPersonales = ({ vieneDeInscritos, inscrito, solicitudesPendientes, handleChange }: DatosPersonalesProps) => {
  const [comunidad, setComunidad] = useState<CommunityModel | null>(null);

  useEffect(() => {
    const id = vieneDeInscritos ? inscrito?.idComunidad : solicitudesPendientes?.comunidad;
    if (id === undefined) return;
    new CommunitiesService().getCommunity(id).then((response) => {
      setComunidad(response);
    });
  }, [inscrito, solicitudesPendientes]);

  const isEmpresa = (vieneDeInscritos ? inscrito?.tipoInscrito : solicitudesPendientes?.tipo_solicitante) === 'empresa';

  const formFieldsLeftCUPS: Array<FormGroupProps> = [
    {
      label: I18n.t('InscritosDetalle.comunidadAsociada'),
      type: 'string',
      id: 'idComunidad',
      path: 'idComunidad',
      name: 'idComunidad',
      value: comunidad?.nombre,
      placeholder: '',
      readOnly: !vieneDeInscritos,
    },
    {
      label: 'CUPS',
      type: 'string',
      id: 'cups',
      path: 'cups',
      name: 'cups',
      value: vieneDeInscritos ? inscrito?.cups || '' : solicitudesPendientes?.cups || '',
      placeholder: '',
      readOnly: !vieneDeInscritos,
    },
  ];
  const formFieldsLeft: Array<FormGroupProps> = [
    {
      label: I18n.t('InscritosDetalle.nombre'),

      type: 'string',
      id: 'nombre',
      path: 'nombre',
      name: 'nombre',
      value: vieneDeInscritos ? inscrito?.nombre : solicitudesPendientes?.nombre,
      placeholder: '',

      readOnly: !vieneDeInscritos,
    },
    {
      label: I18n.t('InscritosDetalle.apellidos'),

      type: 'string',
      id: 'apellidos',
      path: 'apellidos',
      name: 'apellidos',
      value: vieneDeInscritos ? inscrito?.apellidos : solicitudesPendientes?.apellidos,
      placeholder: '',
      readOnly: !vieneDeInscritos,
    },

    {
      label: I18n.t('InscritosDetalle.telefon'),

      type: 'string',
      id: 'telefono',
      path: 'telefono',
      name: 'telefon',
      value: vieneDeInscritos ? inscrito?.telefono : solicitudesPendientes?.telefono,
      placeholder: '',

      readOnly: !vieneDeInscritos,
    },

    {
      label: I18n.t('InscritosDetalle.domicilio'),

      type: 'string',
      id: 'domicilio',
      path: 'domicilio',
      name: 'domicilio',
      value: vieneDeInscritos ? inscrito?.domicilio : solicitudesPendientes?.domicilio,
      readOnly: !vieneDeInscritos,
      placeholder: '',
    },

    ...(isEmpresa
      ? [
          {
            label: I18n.t('InscritosDetalle.nifEmpresa'),
            type: 'string',
            id: 'nifEmpresa',
            path: 'nifEmpresa',
            name: 'nifEmpresa',
            readOnly: !vieneDeInscritos,
            value: vieneDeInscritos ? inscrito?.nifEmpresa : solicitudesPendientes?.nif_empresa,
            placeholder: '',
          },
          {
            label: I18n.t('InscritosDetalle.domicilioFiscal'),
            type: 'string',
            id: 'domicilioFiscal',
            path: 'domicilioFiscal',
            name: 'domicilioFiscal',
            readOnly: !vieneDeInscritos,
            value: vieneDeInscritos ? inscrito?.domicilioFiscal : solicitudesPendientes?.domicilio_fiscal,
            placeholder: '',
          },
        ]
      : []),
  ];

  const formFieldsRight: Array<FormGroupProps> = [
    {
      label: I18n.t('InscritosDetalle.Dni'),
      type: 'string',
      id: 'nif',
      path: 'nif',
      name: 'nif',
      placeholder: '',
      value: vieneDeInscritos ? inscrito?.nif : solicitudesPendientes?.nif,

      readOnly: !vieneDeInscritos,
    },

    {
      label: I18n.t('InscritosDetalle.Email'),
      type: 'string',
      id: 'email',
      path: 'email',
      name: 'email',
      value: vieneDeInscritos ? inscrito?.email : solicitudesPendientes?.email,
      placeholder: '',
      readOnly: !vieneDeInscritos,
    },
    ...(vieneDeInscritos
      ? [
          {
            label: I18n.t('DatadisRenewal.knownExpiration'),
            type: 'string',
            id: 'fechaCaducidadDatadis',
            path: 'fechaCaducidadDatadis',
            name: 'fechaCaducidadDatadis',
            value: inscrito?.fechaCaducidadDatadis || I18n.t('DatadisRenewal.unknown'),
            placeholder: '',
            readOnly: true,
          },
        ]
      : []),
    {
      label: I18n.t('InscritosDetalle.Direccion'),

      type: 'string',
      id: 'Direccion',
      path: 'direccionCompleta',
      name: 'Direccion',
      value: vieneDeInscritos ? inscrito?.direccionCompleta : solicitudesPendientes?.direccion_completa,
      placeholder: '',
      readOnly: !vieneDeInscritos,
    },

    {
      label: I18n.t('InscritosDetalle.poblacion'),

      type: 'string',
      id: 'poblacion',
      path: 'poblacion',
      name: 'poblacion',
      value: vieneDeInscritos ? inscrito?.poblacion : solicitudesPendientes?.poblacion,
      placeholder: '',
      readOnly: !vieneDeInscritos,
    },

    {
      label: I18n.t('InscritosDetalle.provincia'),

      type: 'string',
      id: 'provincia',
      path: 'provincia',
      name: 'provincia',
      value: vieneDeInscritos ? inscrito?.provincia : solicitudesPendientes?.provincia,
      placeholder: '',
      readOnly: !vieneDeInscritos,
    },
    {
      label: I18n.t('InscritosDetalle.codigoPostal'),

      type: 'string',
      id: 'codigoPostal',
      path: 'codigoPostal',
      name: 'codigoPostal',
      value: vieneDeInscritos ? inscrito?.codigoPostal : solicitudesPendientes?.codigo_postal,
      placeholder: '',
      readOnly: !vieneDeInscritos,
    },

    ...(isEmpresa
      ? [
          {
            label: I18n.t('InscritosDetalle.codigoPostalFiscal'),
            type: 'string',
            id: 'codigoPostalFiscal',
            path: 'codigoPostalFiscal',
            name: 'codigoPostalFiscal',
            readOnly: !vieneDeInscritos,
            value: vieneDeInscritos ? inscrito?.codigoPostalFiscal : solicitudesPendientes?.codigo_postal_fiscal,
            placeholder: '',
          },
          {
            label: I18n.t('InscritosDetalle.razonSocial'),
            type: 'string',
            id: 'razonSocialEmpresa',
            path: 'razonSocialEmpresa',
            name: 'razonSocialEmpresa',
            readOnly: !vieneDeInscritos,
            value: vieneDeInscritos ? inscrito?.razonSocialEmpresa : solicitudesPendientes?.razon_social_empresa,
            placeholder: '',
          },
        ]
      : []),
  ];
  const arrayForcheckox: Array<FormGroupProps> = [
    {
      label: I18n.t('InscritosDetalle.tipoInscrito'),
      type: FORMGROUP_TYPES.select,
      id: 'tipoInscrito',
      path: 'tipoInscrito',
      name: 'tipoInscrito',
      placeholder: 'wwww',
      disabled: !vieneDeInscritos,
      value: vieneDeInscritos ? inscrito?.tipoInscrito : solicitudesPendientes?.tipo_solicitante,
      options: [
        { label: 'Particular', value: 'particular' },
        { label: 'Empresa', value: 'empresa' },
      ],
    },
  ];

  const formcheckbosleft: Array<FormGroupProps> = [
    {
      label: I18n.t('InscritosDetalle.tipoPropiedad'),

      type: FORMGROUP_TYPES.select,
      id: 'tipoPropiedad',
      path: 'tipoPropiedad',
      name: 'tipoPropiedad',
      placeholder: 'wwww',
      disabled: !vieneDeInscritos,
      value: vieneDeInscritos ? inscrito?.tipoPropiedad : solicitudesPendientes?.tipo_propiedad,
      options: [
        { label: 'Propietario', value: 'propietario' },
        { label: 'Alquiler', value: 'alquiler' },
        { label: 'Otros', value: 'otros' },
      ],
    },
  ];

  return (
    <form className={styles.form}>
      <div className={styles.posotionradio}>
        <div className={styles.flex}>
          <SectionTitle text={I18n.t('Dades personals')} />
        </div>

        <div className={styles.containerForms} style={{ marginBottom: '1rem' }}>
          <div className={styles.containerForm} />
        </div>
        <div className={styles.containerForms}>
          <div className={styles.containerForm}>
            {formFieldsLeftCUPS.map((formGroup: FormGroupProps) => (
              <FormGroup
                key={formGroup.id}
                label={formGroup.label}
                type={formGroup.type}
                id={formGroup.id}
                path={formGroup.path}
                name={formGroup.name}
                placeholder={formGroup.placeholder}
                value={formGroup.value}
                required={formGroup.required}
                readOnly={formGroup.readOnly}
                className={formGroup.className}
                maxLenght={200}
                onChange={handleChange}
              />
            ))}
            {formFieldsLeft.map((formGroup: FormGroupProps) => (
              <FormGroup
                key={formGroup.id}
                label={formGroup.label}
                type={formGroup.type}
                id={formGroup.id}
                path={formGroup.path}
                name={formGroup.name}
                placeholder={formGroup.placeholder}
                value={formGroup.value}
                required={formGroup.required}
                readOnly={formGroup.readOnly}
                className={formGroup.className}
                maxLenght={200}
                onChange={handleChange}
              />
            ))}
            {arrayForcheckox.map((formGroup: FormGroupProps) => (
              <FormGroup
                key={formGroup.id}
                label={formGroup.label}
                type={formGroup.type}
                id={formGroup.id}
                path={formGroup.path}
                name={formGroup.name}
                placeholder={formGroup.placeholder}
                value={formGroup.value}
                required={formGroup.required}
                options={formGroup.options}
                readOnly={formGroup.readOnly}
                disabled={formGroup.disabled}
                onChange={handleChange}
              />
            ))}
          </div>
          <div className={styles.containerForms}>
            <div className={styles.containerForm}>
              {formFieldsRight.map((formGroup: FormGroupProps) => (
                <FormGroup
                  key={formGroup.id}
                  label={formGroup.label}
                  type={formGroup.type}
                  id={formGroup.id}
                  path={formGroup.path}
                  name={formGroup.name}
                  placeholder={formGroup.placeholder}
                  value={formGroup.value}
                  required={formGroup.required}
                  readOnly={formGroup.readOnly}
                  className={formGroup.className}
                  maxLenght={200}
                  onChange={handleChange}
                />
              ))}

              {formcheckbosleft.map((formGroup: FormGroupProps) => (
                <FormGroup
                  key={formGroup.id}
                  label={formGroup.label}
                  type={formGroup.type}
                  id={formGroup.id}
                  path={formGroup.path}
                  name={formGroup.name}
                  placeholder={formGroup.placeholder}
                  value={formGroup.value}
                  required={formGroup.required}
                  options={formGroup.options}
                  readOnly={formGroup.readOnly}
                  disabled={formGroup.disabled}
                  onChange={handleChange}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default DatosPersonales;
